import { z } from 'zod';

import { CreateSetDateWindowSchema } from '../filters/date-window.js';

export const SET_NAME_MIN = 3;
export const SET_NAME_MAX = 100;

/**
 * Matches only ASCII-safe characters: letters, digits, spaces,
 * and common punctuation (hyphens, underscores, periods, commas,
 * ampersands, parentheses, apostrophes).
 */
const ENGLISH_SAFE_PATTERN = /^[a-zA-Z0-9 \-_.,&()']+$/;

export const SetNameSchema = z
  .string()
  .trim()
  .min(SET_NAME_MIN, `Name must be at least ${SET_NAME_MIN} characters`)
  .max(SET_NAME_MAX, `Name must be ${SET_NAME_MAX} characters or fewer`)
  .regex(
    ENGLISH_SAFE_PATTERN,
    'Name can only contain English letters, numbers, spaces, and basic punctuation (- _ . , & () \')',
  );

export const IndustrySchema = z.string().trim().min(1, 'Industry is required');

export const CreateSetBodySchema = z
  .object({
    name: SetNameSchema.optional(),
    industry: IndustrySchema,
    myBrand: z.string().max(255).nullish(),
    mainCompetitor: z.string().max(255).nullish(),
    industryCompetitors: z.array(z.string().trim().min(1)).optional(),
    products: z.array(z.string().trim().min(1)).optional(),
    adPlatforms: z.array(z.string().trim().min(1)).optional(),
    strategicPriorities: z.object({
      focusOn: z.array(z.string().trim().min(1)).optional(),
      avoid: z.array(z.string().trim().min(1)).optional(),
    }).optional(),
    brandVoice: z.object({
      alwaysSay: z.string().trim().optional(),
      neverSay: z.string().trim().optional(),
    }).optional(),
    scriptGuidelines: z.string().trim().optional(),
  })
  .and(CreateSetDateWindowSchema);

export type CreateSetBody = z.infer<typeof CreateSetBodySchema>;
